import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const { processGoogleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(window.location.hash.substring(1)).get("session_id");
    if (!sessionId) { navigate("/", { replace: true }); return; }
    processGoogleSession(sessionId)
      .then(() => { window.history.replaceState(null, "", "/"); navigate("/", { replace: true }); })
      .catch(() => navigate("/", { replace: true }));
  }, [processGoogleSession, navigate]);

  return (
    <div className="fixed inset-0 bg-bg flex items-center justify-center z-50">
      <div className="text-center">
        <div className="w-10 h-10 border-3 border-view-a border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-heading text-2xl text-dark">GETTING YOU IN...</p>
      </div>
    </div>
  );
}
